import * as PortalPrimitive from "@radix-ui/react-portal"

interface PortalProps extends PortalPrimitive.PortalProps {}

/**
 * Portal component
 * @description A component that renders its children in a portal. We use this instead of the native React portal component to avoid having to add the portal container to the DOM. This component will automatically add the portal container to the DOM when it is rendered and will keep track of different portals.
 */
export function Portal(props: PortalProps) {
  return <PortalPrimitive.Root {...props} />
}
